// src/components/user/FaqUsuario.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import {
  FaEnvelope,
  FaInstagram,
  FaChevronDown,
  FaHeadset
} from 'react-icons/fa';
import imagen7 from '../../assets/imagen7.jpeg';

const APP_PRIMARY = '#b03060';

const FaqUsuario = () => {
  const [faqs, setFaqs] = useState([]);
  const [abierta, setAbierta] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'faq'));
        const datos = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setFaqs(datos);
        if (datos.length > 0) setAbierta(datos[0].id);
      } catch (err) {
        console.error('Error al cargar preguntas frecuentes:', err);
      }
    };

    fetchFaqs();
  }, []);

  const toggleFaq = (id) => {
    setAbierta((prev) => (prev === id ? null : id));
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.badge}>Centro de Ayuda</span>
        <h2 style={styles.title}>Preguntas Frecuentes</h2>
        <p style={styles.subtitle}>
          Respuestas claras a las dudas más habituales sobre tus rutinas, uso de la app y recomendaciones.
        </p>
      </div>

      <div style={styles.faqList}>
        {faqs.map((faq, idx) => {
          const isOpen = abierta === faq.id;
          return (
            <div
              key={faq.id}
              style={{
                ...styles.faqCard,
                borderColor: isOpen ? '#fbcfe8' : '#f1f5f9',
                boxShadow: isOpen
                  ? '0 8px 24px rgba(176, 48, 96, 0.08)'
                  : '0 2px 8px rgba(0, 0, 0, 0.02)'
              }}
            >
              <button
                type="button"
                onClick={() => toggleFaq(faq.id)}
                style={styles.faqButton}
              >
                <div style={styles.questionWrapper}>
                  <span
                    style={{
                      ...styles.numberBadge,
                      backgroundColor: isOpen ? APP_PRIMARY : '#fdf2f8',
                      color: isOpen ? '#ffffff' : APP_PRIMARY
                    }}
                  >
                    {idx + 1}
                  </span>
                  <span
                    style={{
                      ...styles.questionText,
                      color: isOpen ? '#1e293b' : '#334155',
                      fontWeight: isOpen ? '700' : '600'
                    }}
                  >
                    {faq.pregunta}
                  </span>
                </div>
                <div
                  style={{
                    ...styles.arrowBox,
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    backgroundColor: isOpen ? '#fdf2f8' : '#f8fafc',
                    color: isOpen ? APP_PRIMARY : '#94a3b8'
                  }}
                >
                  <FaChevronDown size={12} />
                </div>
              </button>

              {isOpen && (
                <div style={styles.answerWrapper}>
                  <p style={styles.answerText}>{faq.respuesta}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div style={styles.contactCard}>
        <div style={styles.contactGrid}>
          <div style={styles.imageContainer}>
            <img src={imagen7} alt="Mariana Fitness Trainer" style={styles.image} />
            <div style={styles.imageBadge}>
              <FaHeadset size={12} color="#ffffff" />
              <span>Soporte directo</span>
            </div>
          </div>

          <div style={styles.contactContent}>
            <span style={styles.contactSub}>Atención Personalizada</span>
            <h3 style={styles.contactTitle}>¿Necesitas orientación adicional?</h3>
            <p style={styles.contactDescription}>
              Si deseas resolver dudas puntuales sobre tus ejercicios o coordinar una sesión presencial u online:
            </p>

            <div style={styles.linksStack}>
              <a
                href="mailto:marianafitness.app@gmail.com"
                style={styles.actionChip}
              >
                <div style={{ ...styles.chipIcon, backgroundColor: '#eff6ff', color: '#2563eb' }}>
                  <FaEnvelope size={14} />
                </div>
                <div style={styles.chipText}>
                  <span style={styles.chipLabel}>Escríbeme por Correo</span>
                  <strong style={styles.chipValue}>marianafitness.app@gmail.com</strong>
                </div>
              </a>

              <a
                href="https://www.instagram.com/marianafitnesstrainer_app/"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.actionChip}
              >
                <div style={{ ...styles.chipIcon, backgroundColor: '#fdf2f8', color: APP_PRIMARY }}>
                  <FaInstagram size={16} />
                </div>
                <div style={styles.chipText}>
                  <span style={styles.chipLabel}>Comunidad en Instagram</span>
                  <strong style={styles.chipValue}>@marianafitnesstrainer_app</strong>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqUsuario;

const styles = {
  container: {
    maxWidth: '820px',
    margin: '0 auto',
    padding: '12px 16px 120px 16px',
    boxSizing: 'border-box',
    fontFamily: "'Poppins', sans-serif"
  },
  header: {
    textAlign: 'center',
    marginBottom: '28px'
  },
  badge: {
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: APP_PRIMARY,
    background: '#fdf2f8',
    padding: '4px 12px',
    borderRadius: '20px',
    marginBottom: '8px'
  },
  title: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 6px 0',
    letterSpacing: '-0.3px'
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 1.5
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '32px'
  },
  faqCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    border: '1.5px solid #f1f5f9',
    transition: 'all 0.25s ease',
    overflow: 'hidden'
  },
  faqButton: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',
    padding: '18px 20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    outline: 'none',
    fontFamily: 'inherit'
  },
  questionWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px'
  },
  numberBadge: {
    width: '28px',
    height: '28px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '700',
    flexShrink: 0,
    transition: 'all 0.2s ease'
  },
  questionText: {
    fontSize: '15px',
    lineHeight: 1.4,
    transition: 'color 0.2s ease'
  },
  arrowBox: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'all 0.25s ease'
  },
  answerWrapper: {
    padding: '0 20px 20px 62px'
  },
  answerText: {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.65,
    color: '#475569'
  },
  contactCard: {
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    border: '1px solid #f1f5f9',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)',
    padding: '24px',
    overflow: 'hidden'
  },
  contactGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flexWrap: 'wrap'
  },
  imageContainer: {
    position: 'relative',
    width: '170px',
    height: '170px',
    borderRadius: '16px',
    overflow: 'hidden',
    flexShrink: 0,
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.08)'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  imageBadge: {
    position: 'absolute',
    bottom: '8px',
    left: '8px',
    right: '8px',
    backgroundColor: 'rgba(15, 23, 42, 0.75)',
    backdropFilter: 'blur(6px)',
    borderRadius: '8px',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    color: '#ffffff',
    fontSize: '11px',
    fontWeight: '600'
  },
  contactContent: {
    flex: 1,
    minWidth: '260px'
  },
  contactSub: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: APP_PRIMARY
  },
  contactTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '4px 0 8px 0'
  },
  contactDescription: {
    fontSize: '13px',
    color: '#64748b',
    lineHeight: 1.5,
    margin: '0 0 16px 0'
  },
  linksStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  actionChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 14px',
    borderRadius: '12px',
    backgroundColor: '#fafafa',
    border: '1px solid #f1f5f9',
    textDecoration: 'none',
    transition: 'all 0.2s ease'
  },
  chipIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  chipText: {
    display: 'flex',
    flexDirection: 'column'
  },
  chipLabel: {
    fontSize: '11px',
    color: '#94a3b8',
    fontWeight: '500'
  },
  chipValue: {
    fontSize: '13px',
    color: '#1e293b',
    fontWeight: '600'
  }
};